import type { DeviceOperationUpdateDOMRequest } from '@/domains/scenario/types/device-management-types';
import { APIS, URLS } from '@/shared/config/urls';
import { request } from '@/shared/utils/request';
//
export const fetchDeviceOperationList = async (params = '') => {
  const url = `${URLS.BACK_DSH}${APIS.deviceOprationList(params)}`;
  return await request.get(url);
};
//
export const fetchDetailDeviceOperation = async (params = '') => {
  const url = `${URLS.BACK_DSH}${APIS.detailDeviceOperation(params)}`;
  return await request.get(url);
};
//
export const deleteDeviceOperation = async (deivceOperationId: string | number) => {
  const url = `${URLS.BACK_DSH}${APIS.deleteDeviceOperation(String(deivceOperationId))}`;
  return await request.delete(url);
};
//
export const createDeviceOperation = async (
  deviceOperationData: Record<string, unknown> | DeviceOperationUpdateDOMRequest
) => {
  console.log('createDeviceOperation');
  const url = `${URLS.BACK_DSH}${APIS.createDeviceOperation()}`;
  return await request.post(url, deviceOperationData);
};
//
export const updateDeviceOperation = async (
  deviceOperationData: Record<string, unknown> & { device_operation_id: string | number }
) => {
  const url = `${URLS.BACK_DSH}${APIS.updateDeviceOperation(String(deviceOperationData.device_operation_id))}`;
  return await request.put(url, deviceOperationData);
};

//서버에 DOM전송하는 API - vms 이미지 생성을 위한
export const createDeviceOperationAndDom = async (
  deviceOperationData: FormData | Record<string, unknown> | DeviceOperationUpdateDOMRequest
) => {
  const url = `${URLS.BACK_DSH}${APIS.createDeviceOperationAndDom()}`;
  return await request.post(url, deviceOperationData, false);
};

//서버에있는 VMS의 DOM수정하는 API- vms 이미지 수정을 위한
export const updateDeviceOperationAndDom = async (
  deviceOperationData: FormData | DeviceOperationUpdateDOMRequest
) => {
  const deviceOperationId =
    deviceOperationData instanceof FormData
      ? deviceOperationData.get('device_operation_id')
      : (deviceOperationData as unknown as Record<string, unknown>).device_operation_id;
  const url = `${URLS.BACK_DSH}${APIS.updateDeviceOperationAndDom(String(deviceOperationId))}`;
  return await request.put(url, deviceOperationData, false);
};
